export default "__VITE_ASSET__f592Tc2A__"